import { render, staticRenderFns } from "./ticket-info.vue?vue&type=template&id=a22dea6c&"
import script from "./ticket-info.vue?vue&type=script&lang=js&"
export * from "./ticket-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports